/**
 * Medical Simple Direct Guidance - No Mappings, No Complexity
 * Every requirement ID maps directly to its guidance
 * Based on verified RA content and WBC3 requirements
 */

export const MEDICAL_GUIDANCE = {
  "medical.stores.cat.a": {
    id: "medical.stores.cat.a",
    title: "Medical Stores Category A",
    references: "WBC3 23.1.1.1, MSN 1905",
    placement: "Stowed in dedicated medical locker or room (WBC3 23.1.3). Protected from weather and contamination. Accessible for medical emergencies. Properly secured against movement at sea.",
    specifications: "Medical stores and medicines as per MSN 1905 Annex 1. Category A medical stores per MSN 1905 Annex 1. Complete medical store list per MSN 1905 Schedule. All medicines must be in date and immediately useable (WBC3 23.1.2). Master or competent designate manages stores (WBC3 23.1.3). Risk assessment required if any listed items are omitted (WBC3 23.1.6).",
    maintenance: "Periodic replacement of expired medicines (WBC3 23.1.2). Master or designate management of medical stores (WBC3 23.1.3). Risk assessment if any items omitted (WBC3 23.1.6). Maintain medical store inventory record. Monthly check of medicine expiry dates. Regular inventory check against MSN 1905 requirements.",
    authority: "CSV Classification: MANDATORY for Category 0 vessels (unlimited voyages). WBC3 23.1.1.1/MSN 1905 requirement."
  }
};

/**
 * Simple Direct Lookup - No mappings, no complexity
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getMedicalGuidance(itemId) {
  // Early return - no debug logging for missing guidance
  return MEDICAL_GUIDANCE[itemId] || null;
}